import React from "react";
import {
    Datagrid,
    ArrayField,
    DateField,
    Filter,
    ImageField,
    ImageInput,
    List,
    NumberInput,
    ReferenceField,
    SelectInput,
    SimpleShowLayout,
    TextField,
    ReferenceInput,
    ArrayInput,
    SimpleFormIterator,
    TextInput, required, BooleanInput, maxLength, NumberField,
} from "react-admin";
import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";
import Emoji from "../../components/Emoji";
import { Markets, MarketsFilter } from "../../constants/choices";
import {ColorInput, ColorField} from "react-admin-color-input";
import {PersianDateExpirationDatePicker} from "../../components/PersianDatePickers";

const ConversationAdFilter = (props) => (
    <Filter {...props}>
        <SelectInput
            label="مارکت"
            choices={MarketsFilter}
            optionText={"name"}
            optionValue={"value"}
            source={"markets"}
            alwaysOn
        />
        <TextInput label="شناسه" source="objectId"/>
        <TextInput label="عنوان" source="title"/>
        <TextInput label="توضیحات" source="description"/>
        <TextInput label="رنگ پس زمینه" source="backgroundColor"/>
        <TextInput label="لینک" source="link"/>
        <NumberInput label="ترتیب" source="order"/>
    </Filter>
);

export const ConversationAdList = (props) => (
    <List {...props} filters={<ConversationAdFilter/>}>
        <Datagrid rowClick="show">
            <TextField source="objectId"/>
            <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
            <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
            <DateField showTime={true} locales={"fa-IR"} source="expirationDate"/>
            <TextField source="title"/>
            <TextField source="description"/>
            <NumberField source="order"/>
        </Datagrid>
    </List>
);

export const ConversationAdEdit = (props) => (
    <EditView {...props}>
        <TextInput source="title" validate={[required(), maxLength(24)]}/>
        <b>توضیحات بیشتر از 24 کارکتر نباید باشد.</b>
        <Emoji source="description" label="توضیحات" validate={required()} />
        <TextInput source="link"/>
        <PersianDateExpirationDatePicker
            source="expirationDate"
            label={"تاریخ انقضا"}
        />
        <ImageInput source="image"  label="تصویر مربوطه" accept="image/*">
            <ImageField source="src" title="title"/>
        </ImageInput>
        <TextInput source="imageUrl"/>
        <ImageInput source="backgroundPicture"  label="تصویر پس زمینه" accept="image/*">
            <ImageField source="src" title="title"/>
        </ImageInput>
        <TextInput source="backgroundImageUrl"/>
        <ColorInput source="backgroundColor"/>
        <NumberInput source="order" validate={required()}/>
        <ArrayInput source="adminMarkets">
            <SimpleFormIterator>
                <SelectInput source="markets" choices={Markets} />
            </SimpleFormIterator>
        </ArrayInput>
    </EditView>
);

export const ConversationAdShow = (props) => (
    <ShowView {...props}>
        <SimpleShowLayout>
            <TextField source="objectId"/>
            <ImageField source="imageUrl"/>
            <TextField source="title"/>
            <TextField source="description"/>
            <ColorField source="backgroundColor"/>
            <ImageField source="backgroundImageUrl"/>
            <TextField source="link"/>
            <NumberField source="order"/>
            <ArrayField source="adminMarkets">
                <Datagrid>
                    <TextField source="markets" />
                </Datagrid>
            </ArrayField>
            <DateField showTime={true} locales={"fa-IR"} source="expirationDate"/>
            <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
            <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
        </SimpleShowLayout>
    </ShowView>
);

export const ConversationAdCreate = (props) => (
    <CreateView {...props}>
        <TextInput source="title" validate={[required(), maxLength(24)]}/>
        <b>توضیحات بیشتر از 24 کارکتر نباید باشد.</b>
        <Emoji source="description" label="توضیحات" validate={required()} />
        <TextInput source="link"/>
        <PersianDateExpirationDatePicker
            source="expirationDate"
            label={"تاریخ انقضا"}
        />
        <ImageInput source="image"  label="تصویر مربوطه" accept="image/*">
            <ImageField source="src" title="title"/>
        </ImageInput>
        <TextInput source="imageUrl"/>
        <ImageInput source="backgroundPicture"  label="تصویر پس زمینه" accept="image/*">
            <ImageField source="src" title="title"/>
        </ImageInput>
        <TextInput source="backgroundImageUrl"/>
        <ColorInput source="backgroundColor"/>
        <NumberInput source="order" validate={required()}/>
        <ArrayInput source="adminMarkets">
            <SimpleFormIterator>
                <SelectInput source="markets" choices={Markets} />
            </SimpleFormIterator>
        </ArrayInput>
    </CreateView>
);
